// extracted by mini-css-extract-plugin
module.exports = {"error":"not-found_error__2hjNY","content":"not-found_content__2gHdE","text":"not-found_text__3WIdK","child":"not-found_child__1R6kM"};